export default "__VITE_PUBLIC_ASSET__9be06921__"